(function () {
  'use strict';

  var selector = '[data-accessible-slider]';
  var motionQuery = window.matchMedia
    ? window.matchMedia('(prefers-reduced-motion: reduce)')
    : null;
  var focusableSelector = [
    'a[href]',
    'button:not([disabled])',
    'input:not([disabled])',
    'select:not([disabled])',
    'textarea:not([disabled])',
    '[tabindex]'
  ].join(',');

  function reducedMotionPreferred() {
    return motionQuery && motionQuery.matches;
  }

  function disableConfiguredAutoplay(component) {
    if (!component || !reducedMotionPreferred()) return;

    if (component.config) {
      component.config.autoplay = false;
      return;
    }

    var configElement = component.querySelector('[data-tns-config]');
    if (!configElement || configElement.hasAttribute('data-slider-a11y-motion')) return;

    try {
      var config = JSON.parse(configElement.textContent);
      config.autoplay = false;
      configElement.textContent = JSON.stringify(config);
      configElement.setAttribute('data-slider-a11y-motion', 'reduced');
    } catch (error) {
      /* El inicializador original conserva la configuración si el JSON no se puede leer. */
    }
  }

  function setDescendantFocus(slide, hidden) {
    if ('inert' in slide) slide.inert = hidden;

    slide.querySelectorAll(focusableSelector).forEach(function (element) {
      if (hidden) {
        if (!element.hasAttribute('data-slider-a11y-tabindex')) {
          var original = element.getAttribute('tabindex');
          element.setAttribute('data-slider-a11y-tabindex', original === null ? '__none__' : original);
        }
        element.setAttribute('tabindex', '-1');
      } else if (element.hasAttribute('data-slider-a11y-tabindex')) {
        var stored = element.getAttribute('data-slider-a11y-tabindex');
        if (stored === '__none__') element.removeAttribute('tabindex');
        else element.setAttribute('tabindex', stored);
        element.removeAttribute('data-slider-a11y-tabindex');
      }
    });
  }

  function translateLiveRegion(root) {
    var liveRegion = root.querySelector('.tns-liveregion');
    if (!liveRegion) return;

    var current = liveRegion.querySelector('.current');
    var list = root.querySelector('.slider-list');
    var total = list ? list.querySelectorAll(':scope > .slider-item:not(.tns-slide-cloned)').length : 0;
    if (current && liveRegion.firstChild && liveRegion.firstChild.nodeType === 3) {
      liveRegion.firstChild.nodeValue = 'Diapositiva ';
    }
    if (current && liveRegion.lastChild && liveRegion.lastChild.nodeType === 3 && total) {
      liveRegion.lastChild.nodeValue = ' de ' + total;
    }

    var autoplayButton = root.querySelector('[data-action]');
    var autoplayRunning = autoplayButton && autoplayButton.getAttribute('data-action') === 'stop';
    liveRegion.setAttribute('aria-live', autoplayRunning ? 'off' : 'polite');
    liveRegion.setAttribute('aria-atomic', 'true');
  }

  function enhance(root) {
    var list = root.querySelector('.slider-list');
    if (list) {
      list.setAttribute('role', 'list');
      list.setAttribute('aria-live', 'off');
      Array.prototype.forEach.call(list.children, function (slide) {
        if (!slide.classList.contains('slider-item')) return;
        slide.setAttribute('role', 'listitem');
        setDescendantFocus(slide, slide.getAttribute('aria-hidden') === 'true');
      });
    }

    var controls = root.querySelector('.js-slider-controls');
    if (controls) {
      controls.setAttribute('role', 'group');
      controls.setAttribute('aria-label', root.getAttribute('data-slider-controls-label') || 'Navegación del carrusel');
      controls.removeAttribute('tabindex');

      var previous = controls.querySelector('.js-prev-button');
      var next = controls.querySelector('.js-next-button');
      if (previous) {
        previous.setAttribute('tabindex', previous.getAttribute('aria-disabled') === 'true' ? '-1' : '0');
        previous.setAttribute(
          'aria-label',
          root.getAttribute('data-slider-previous-label') || previous.getAttribute('aria-label') || 'Diapositiva anterior'
        );
      }
      if (next) {
        next.setAttribute('tabindex', next.getAttribute('aria-disabled') === 'true' ? '-1' : '0');
        next.setAttribute(
          'aria-label',
          root.getAttribute('data-slider-next-label') || next.getAttribute('aria-label') || 'Diapositiva siguiente'
        );
      }
    }

    var navigation = root.querySelector('.tns-nav, .js-slider-dots');
    if (navigation) {
      navigation.setAttribute('role', 'group');
      navigation.setAttribute('aria-label', root.getAttribute('data-slider-pagination-label') || 'Paginación del carrusel');
      navigation.removeAttribute('tabindex');
      navigation.querySelectorAll('button').forEach(function (button, index) {
        button.setAttribute('aria-label', 'Ir a la diapositiva ' + (index + 1));
        if (button.classList.contains('tns-nav-active')) button.setAttribute('aria-current', 'true');
        else button.removeAttribute('aria-current');
      });
    }

    var autoplayButton = root.querySelector('[data-action]');
    if (autoplayButton) {
      var paused = autoplayButton.getAttribute('data-action') === 'start';
      autoplayButton.classList.add('slider-a11y-autoplay-toggle');
      autoplayButton.setAttribute('aria-label', paused ? 'Reanudar carrusel' : 'Pausar carrusel');
      autoplayButton.removeAttribute('aria-pressed');
      autoplayButton.setAttribute('title', paused ? 'Reanudar carrusel' : 'Pausar carrusel');
    }

    translateLiveRegion(root);

    var component = root.querySelector('slider-component');
    disableConfiguredAutoplay(component);
    var api = component && component.slider;
    if (api && root._sliderA11yApi !== api) {
      root._sliderA11yApi = api;
      if (reducedMotionPreferred() && typeof api.pause === 'function') api.pause();
    }
  }

  function scheduleEnhancement(root) {
    if (root._sliderA11yFrame) return;
    root._sliderA11yFrame = window.requestAnimationFrame(function () {
      root._sliderA11yFrame = null;
      enhance(root);
    });
  }

  function install(root) {
    if (!root || root.hasAttribute('data-slider-a11y-ready')) return;
    root.setAttribute('data-slider-a11y-ready', 'true');

    var observer = new MutationObserver(function () {
      scheduleEnhancement(root);
    });
    observer.observe(root, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['aria-hidden', 'class', 'data-action']
    });

    root.addEventListener('focusin', function (event) {
      if (root.getAttribute('data-slider-autoplay') !== 'true' || event.target.closest('[data-action]')) return;
      var autoplayButton = root.querySelector('[data-action="stop"]');
      var component = root.querySelector('slider-component');
      if (autoplayButton && component && component.slider && typeof component.slider.pause === 'function') {
        component.slider.pause();
        scheduleEnhancement(root);
      }
    });

    enhance(root);
  }

  function scan(scope) {
    var context = scope || document;
    if (context.matches && context.matches(selector)) install(context);
    context.querySelectorAll(selector).forEach(install);
  }

  if (window.ThemeSliderAccessibility) {
    window.ThemeSliderAccessibility.scan(document);
    return;
  }

  window.ThemeSliderAccessibility = { scan: scan };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { scan(document); });
  else scan(document);

  document.addEventListener('shopify:section:load', function (event) { scan(event.target); });

  function handleMotionChange(event) {
    if (!event.matches) return;
    document.querySelectorAll(selector).forEach(function (root) {
      var component = root.querySelector('slider-component');
      disableConfiguredAutoplay(component);
      if (component && component.slider && typeof component.slider.pause === 'function') component.slider.pause();
      scheduleEnhancement(root);
    });
  }

  if (motionQuery) {
    if (motionQuery.addEventListener) motionQuery.addEventListener('change', handleMotionChange);
    else if (motionQuery.addListener) motionQuery.addListener(handleMotionChange);
  }
})();
